import { render } from "./PrivateUploadButton.vue?vue&type=template&id=875f8f5a"
import script from "./PrivateUploadButton.vue?vue&type=script&lang=js"
export * from "./PrivateUploadButton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__